import React, { useState, useEffect } from "react";
import {
  Image,
  Table,
  Button,
  Segment,
  Icon,
  Menu,
  Message,
} from "semantic-ui-react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import StudentForm from "./StudentForm";
import EditStudentForm from "./EditStudent";
import SearchInput from "../../common/SearchInput";
import UserCard from "../../common/UserCard";
import CodeModal from "../../common/CodeModal";
import { Skeleton, Empty } from "antd";

function StudentsData({ school }) {
  const [students, setStudents] = useState([]);
  const [student, setStudent] = useState({});
  const [errors, setErrors] = useState({
    response: { show: false, type: "success", message: "" },
  });
  const [studentUUID, setId] = useState("");
  const [showUser, setShowUser] = useState({ show: false, data: {} });

  const [showModal, setShowModal] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [processing, setProcess] = useState(false);
  const [isCreated, setCreated] = useState(false);
  const [isDeleted, setDeleted] = useState(false);
  const [isUpdated, setUpdated] = useState(false);
  const [showCode, setShowCode] = useState({ show: false, data: {} });
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const token = localStorage.getItem("token");
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/students/${school.uuid}`,
          { headers: { token } }
        );
        setLoading(false);
        console.log(response.data.data);
        setStudents(response.data.data);
      } catch (error) {
        setLoading(false);
        console.log(error.message, "err");
        if (error?.message === "Network Error") {
          setErrors({
            ...errors,
            response: {
              show: true,
              type: "error",
              message: error.message,
            },
          });
          // return setTimeout(
          //   () => setErrors({ ...errors, response: { show: false } }),
          //   3000
          // );
        }
        return error;
      }
    };
    fetchStudents();
    // return () => setDeleted(false);
  }, [isCreated, isDeleted, isUpdated, page]);

  const handleDeleteStudent = async (studentId) => {
    try {
      setId(studentId);
      setProcess(true);
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/students/${school.uuid}/${studentId}`,
        { headers: { token: localStorage.getItem("token") } }
      );
      if (response.status === 200) {
        setProcess(false);
        setDeleted(true);
        setDeleted(false);
      }
    } catch (error) {
      setProcess(false);
      if (error.message === "Network Error") {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.message,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 403) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 404) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      if (error?.response.status === 500) {
        setErrors({
          ...errors,
          response: {
            show: true,
            type: "error",
            message: error.response.data.error,
          },
        });
        return setTimeout(
          () => setErrors({ ...errors, response: { show: false } }),
          3000
        );
      }
      setErrors({
        ...errors,
        response: {
          show: true,
          type: "error",
          message: error.response.data.error,
        },
      });
      return setTimeout(
        () => setErrors({ ...errors, response: { show: false } }),
        3000
      );
    }
  };

  return (
    <>
      {loading ? (
        <>
          <Skeleton.Button
            active
            shape="round"
            className="p-2"
            size="default"
          />
          <Skeleton active avatar paragraph={{ rows: 4 }} className="p-2" />
        </>
      ) : (
        <Container>
          <Message
            content={errors.response.message}
            hidden={!errors.response.show}
            positive={errors.response.type === "success"}
            negative={errors.response.type === "error"}
          />
          <StudentForm
            showModal={showModal}
            setShowModal={setShowModal}
            school={school}
            setCreated={setCreated}
            setShowCode={setShowCode}
          />
          <EditStudentForm
            showModal={showUpdate}
            setShowModal={setShowUpdate}
            school={school}
            student={student}
            setUpdated={setUpdated}
          />
          <UserCard
            showModal={showUser}
            setShowModal={setShowUser}
            showUpdate={setShowUpdate}
            setUser={setStudent}
            deleteUser={handleDeleteStudent}
            processing={processing}
          />
          <CodeModal showCode={showCode} setShowCode={setShowCode} />
          {students.length <= 0 ? (
            <Segment placeholder>
              {/* <Header icon>
                <Icon name='student' />
                No students are listed for this school.
              </Header>
              <Button
                primary
                onClick={() => {
                  // setCreated(false);
                  setShowModal(true);
                }}
              >
                Add Student
              </Button> */}
              <Empty>
                <Button
                  primary
                  onClick={() => {
                    // setCreated(false);
                    setShowModal(true);
                  }}
                >
                  Add Student
                </Button>
              </Empty>
            </Segment>
          ) : (
            <Row>
              <Col lg={9}>
                <Button
                  basic
                  positive
                  style={{ marginBottom: 10, borderRadius: 50 }}
                  onClick={() => {
                    // setCreated(false);
                    setShowModal(true);
                  }}
                >
                  <Icon name="add" />
                  Add new
                </Button>
              </Col>
              <Col>
                <SearchInput
                  data={students}
                  fn={(value) => setShowUser({ show: true, data: value })}
                />
              </Col>
              <Col lg={12}>
                <Table striped color="red" columns={7}>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell textAlign="center">
                        Image
                      </Table.HeaderCell>
                      <Table.HeaderCell>First Name</Table.HeaderCell>
                      <Table.HeaderCell>Last Name</Table.HeaderCell>
                      <Table.HeaderCell>Date of Birth</Table.HeaderCell>
                      <Table.HeaderCell>Address</Table.HeaderCell>
                      <Table.HeaderCell>Level</Table.HeaderCell>
                      <Table.HeaderCell textAlign={"center"}>
                        Actions
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {students.map((student) => {
                      return (
                        <Table.Row>
                          <Table.Cell
                            textAlign="center"
                            style={{ border: "none" }}
                          >
                            <Image
                              src={`${
                                student.image
                                  ? student.image
                                  : process.env.REACT_APP_DEF_IMAGE
                              }`}
                              avatar
                            />
                          </Table.Cell>
                          <Table.Cell style={{ border: "none" }}>
                            {student.firstName}{" "}
                          </Table.Cell>
                          <Table.Cell style={{ border: "none" }}>
                            {" "}
                            {student.lastName}
                          </Table.Cell>
                          <Table.Cell style={{ border: "none" }}>
                            {`${new Date(student.dob).getDate()}-${
                              new Date(student.dob).getMonth() + 1
                            }-${new Date(student.dob).getFullYear()}`}{" "}
                          </Table.Cell>
                          <Table.Cell style={{ border: "none" }}>
                            {student.address}
                          </Table.Cell>
                          <Table.Cell
                            negative={!student.level}
                            style={{ border: "none" }}
                          >
                            {student.level || "N/A"}
                          </Table.Cell>
                          <Table.Cell
                            textAlign="center"
                            style={{ border: "none" }}
                          >
                            <Button
                              circular
                              primary
                              icon="edit"
                              onClick={() => {
                                setUpdated(false);
                                setStudent(student);
                                setShowUpdate(true);
                              }}
                            />
                            <Button
                              circular
                              negative
                              icon="trash"
                              loading={
                                processing && studentUUID === student.uuid
                              }
                              onClick={() => handleDeleteStudent(student.uuid)}
                            />
                            <Button
                              circular
                              basic
                              icon="eye"
                              onClick={() =>
                                setShowCode({
                                  show: true,
                                  data: student.uuid,
                                  names: `${student.firstName}_${student.lastName}`,
                                })
                              }
                            />
                          </Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                  <Table.Footer>
                    <Table.Row>
                      <Table.HeaderCell colSpan="7">
                        <Menu floated="right" pagination>
                          <Menu.Item
                            as="a"
                            icon
                            onClick={() => setPage(page - 1)}
                          >
                            <Icon name="chevron left" />
                          </Menu.Item>
                          <Menu.Item
                            as="a"
                            onClick={({ target }) =>
                              setPage(target.textContent)
                            }
                          >
                            1
                          </Menu.Item>
                          {Array.from({
                            length: Math.round(students.length / 5),
                          }).map((_, index) => {
                            return (
                              <Menu.Item
                                as="a"
                                onClick={({ target }) =>
                                  setPage(target.textContent)
                                }
                              >
                                {index + 2}
                              </Menu.Item>
                            );
                          })}
                          <Menu.Item
                            as="a"
                            icon
                            onClick={() => setPage(page + 1)}
                          >
                            <Icon name="chevron right" />
                          </Menu.Item>
                        </Menu>
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Footer>
                </Table>
              </Col>
            </Row>
          )}
        </Container>
      )}
    </>
  );
}

export default StudentsData;
